import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { StaticUrls } from '../models';
import { MyCookieService } from './my-cookie.service';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class OrarioService {
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp,
		@Inject(MyCookieService) private myCookieService: MyCookieService
  ) { }
  
  /**
   * Restituisce il numero degli appuntamenti confermati futuri
   */
  getNumeroProssimiAppuntamenti(): Observable<number> {
		if(this.myCookieService.token){
			
			return this.http.get(StaticUrls._orario_num_pross_ap, this.options)
				.map(response => {
						return response.json();
				});
		}
	}

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/orario.service.ts